'use strict';

import { threeJsVariables } from '../../settings';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { LinearSRGBColorSpace, Vector2 } from 'three';
import { changeLangToCurrent } from '../components/langSwitcher/langSwitcher';
import {Switch} from "../interfaces/switchers/Switch";
import { Effect } from '../post-processing/Passes/Effect';
import {BaseElement} from "../interfaces/BaseElement";

export class BuildingOutline {
    static #outline;
    static #outlineBuildings = [];
    static #displayOption = null;
    static #switcher = null;
    #active = config.features.buildingOutline?.active || false;
    #checked = config.features.buildingOutline?.checked || false;
    #visibleColor = config.features.buildingOutline?.visibleColor || '#ffffff';
    #hiddenColor = config.features.buildingOutline?.hiddenColor || '#ffffff';
    #strength = config.features.buildingOutline?.strength || 3;

    constructor (name) {
        if (!this.#active)
            return;

        if (!BuildingOutline.#outline) {
            // BuildingOutline.#displayOption = createHtmlElement('','','div',['building-outline__container']);
            BuildingOutline.#displayOption = new BaseElement()
                .addClass('building-outline__container');
            // const option = createHtmlElement(BuildingOutline.#displayOption.DOMElement,'','div',['building-outline__option','display-option']);
            const option = new BaseElement()
                .addClass('building-outline__option','display-option')
                .appendTo(BuildingOutline.#displayOption.DOMElement);
            // const text = createHtmlElement(option.DOMElement, changeLangToCurrent('Building outline'),'span',['building-outline__text','language-string']);
            // text.setAttribute('data-dictionary', 'Building outline');
            new BaseElement('span')
                .addClass('building-outline__text','language-string')
                .innerHtml(changeLangToCurrent('Building outline'))
                .addAttribute('data-dictionary', 'Building outline')
            BuildingOutline.#switcher = new Switch(option.DOMElement);
            BuildingOutline.#switcher.checked = this.#checked;
            BuildingOutline.#switcher.listener = BuildingOutline.toggle;
            BuildingOutline.#outline = new BuildingOutlineEffect(BuildingOutline.#outlineBuildings,{
                strength: this.#strength,
                visibleColor: this.#visibleColor,
                hiddenColor: this.#hiddenColor
            });
            threeJsVariables.composer.addPass('buildingOutline',BuildingOutline.#outline);
            BuildingOutline.toggle();
        }

        const building = threeJsVariables.scene.getObjectByName(name);
        if (building)
            BuildingOutline.#outlineBuildings.push(building);
    }

    static addToDisplayOptions(container) {
        if (!BuildingOutline.#displayOption)
            return;

        container.appendChild(BuildingOutline.#displayOption.DOMElement);
    }

    static toggle(action) {
        if (BuildingOutline.#outline) {
            if (action instanceof Event) {
                BuildingOutline.#outline.active = action.target.checked;
                BuildingOutline.#switcher.checked = action.target.checked;
            } else {

                if (!BuildingOutline.#switcher.checkbox.checked) {
                    BuildingOutline.#outline.active = false;
                } else {
                    BuildingOutline.#outline.active = action;
                }
            }
        }
    }
}

class BuildingOutlineEffect extends Effect{
    constructor (outlineArray,params = {}) {
        super();
        const renderSize = threeJsVariables.renderer.getSize(new Vector2());
        this.effect = new OutlinePass(renderSize,threeJsVariables.scene,threeJsVariables.perspectiveCamera,outlineArray);
        this.effect.edgeStrength = params.strength;
        this.effect.visibleEdgeColor.setStyle(params.visibleColor,LinearSRGBColorSpace);
        this.effect.hiddenEdgeColor.setStyle(params.hiddenColor,LinearSRGBColorSpace);
        this.effect.downSampleRatio = 2;
    }

}
